const mediaItems = [
  {
    title: '韩漫腐热门作品精选合集',
    desc: '一次性收录当前最火爆的韩漫腐完结与新番作品，从都市情缘到奇幻冒险，带你领略韩漫腐的独特魅力。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20collage%20of%20romantic%20male%20characters%2C%20modern%20fashion%2C%20soft%20pastel%20color%20palette%2C%20clean%20minimal%20design%2C%20warm%20rose%20and%20peach%20tones%2C%20editorial%20layout%2C%20elegant%20composition&width=800&height=450&seq=media-showcase-01&orientation=landscape',
    tag: '韩漫腐',
  },
  {
    title: '日漫腐经典必读推荐',
    desc: '从校园纯爱到职场恋情，精挑细选口碑爆棚的日漫腐佳作，每一部都是经得起时间考验的经典。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20art%20collection%20of%20beautiful%20young%20men%20in%20various%20settings%2C%20soft%20watercolor%20texture%2C%20cherry%20blossom%20accents%2C%20warm%20nostalgic%20tone%2C%20clean%20composition%20with%20negative%20space&width=800&height=450&seq=media-showcase-02&orientation=landscape',
    tag: '日漫腐',
  },
  {
    title: '国漫耽美原创力作巡礼',
    desc: '支持本土原创，发掘国漫耽美中那些画风精美、剧情扎实的作品，见证国漫耽美的崛起之路。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20guoman%20danmei%20style%20art%20showcase%2C%20traditional%20ink%20painting%20blended%20with%20modern%20digital%20art%2C%20elegant%20male%20characters%20in%20hanfu%2C%20warm%20golden%20and%20crimson%20accents%2C%20artistic%20composition%20with%20lotus%20motifs&width=800&height=450&seq=media-showcase-03&orientation=landscape',
    tag: '国漫耽美',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精彩专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按风格分类的腐漫专题合集，快速发现你的喜好</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}